import { Injectable } from "@angular/core";
import * as Rx from "rxjs";

@Injectable()
export class WindowScrollService {

  public scrollObservable = Rx.Observable.fromEvent(window, "scroll")
    .map(() => window.scrollY);
}



// WEBPACK FOOTER //
// ./src/app/services/window/window-scroll.service.ts